<!-- Rename Analysis Group Modal -->
@if (showRenameAnalysisGroupModal) {
  <app-lex-xi-modal
    [isVisible]="showRenameAnalysisGroupModal"
    maxWidth="418px"
    (close)="onRenameAnalysisGroupDialogClosed()"
  >
    <ng-template appXIModalContent>
      @if (showRenameAnalysisGroupModal) {
        <app-rename-analysis-group
          [analysisGroup]="currentAnalysisGroup"
          [project]="project"
          (modalClosed)="onRenameAnalysisGroupDialogClosed($event)"
        ></app-rename-analysis-group>
      }
    </ng-template>
  </app-lex-xi-modal>
}

<!-- Edit Analysis Group Modal -->
@if (showNewAnalysisGroupModal) {
  <app-lex-xi-modal
    [isVisible]="showNewAnalysisGroupModal"
    [canBackdropClose]="false"
    maxWidth="80vw"
    (close)="onNewAnalysisGroupDialogClosed()"
  >
    <ng-template appXIModalContent>
      @if (showNewAnalysisGroupModal) {
        <app-new-analysis-group
          [data]="newAnalysisGroupModalData"
          (modalClosed)="onNewAnalysisGroupDialogClosed($event)"
        ></app-new-analysis-group>
      }
    </ng-template>
  </app-lex-xi-modal>
}
